var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.0159,
    height: 32.014,
    rx: 8,
    fill: "#FCCA5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7907 22.4298L18.45 7.93802C17.8245 6.8607 16.1911 6.82594 15.5656 7.93802L7.22497 22.4298C6.59943 23.5072 7.39874 24.8973 8.68458 24.8973H25.331C26.6169 24.8973 27.4162 23.5419 26.7907 22.4298ZM16.9209 19.4014C17.7897 19.4014 18.5195 20.1312 18.5195 21C18.5195 21.9036 17.7897 22.5986 16.9209 22.5986C16.0174 22.5986 15.3223 21.9036 15.3223 21C15.3223 20.1312 16.0174 19.4014 16.9209 19.4014ZM15.4961 13.6722C15.4613 13.4289 15.6698 13.2204 15.9131 13.2204H18.1025C18.3458 13.2204 18.5543 13.4289 18.5195 13.6722L18.2763 18.3985C18.2415 18.6418 18.0678 18.7808 17.8593 18.7808H16.1564C15.9479 18.7808 15.7741 18.6418 15.7393 18.3985L15.4961 13.6722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e7c043f3903d624f83bc26c5d978356f.svg";
export { ForwardRef as ReactComponent };